// src/components/Clients/Form/GeneralInfo.js

import React from "react";
import { Form, Input, Typography, Row, Col, Switch, Tooltip, Select } from "antd";
import { PhoneOutlined, MailOutlined, UserOutlined, CarOutlined, LinkOutlined, IdcardOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

const { Title, Text } = Typography;
const { Option } = Select;

const GeneralInfo = ({
  esTai = false,
  onTaiChange,
  clientesEps = [],
  loadingClientesEps = false,
  clientesEpsSeleccionados = [],
  onClientesEpsChange,
}) => (
  <div style={{ marginBottom: "24px" }}>
    <Title
      level={4}
      style={{
        marginBottom: 16,
        backgroundColor: "#0a2e5c",
        color: "white",
        padding: "8px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <UserOutlined style={{ marginRight: "8px" }} />
      Información General
    </Title>

    <Row gutter={16}>
      <Col span={16}>
        <Form.Item
          label="Nombre del Cliente"
          name="nombre_cliente"
          rules={[
            {
              required: true,
              message: "Por favor ingrese el nombre del cliente",
            },
            {
              min: 2,
              message: "El nombre del cliente debe tener al menos 2 caracteres",
            },
            {
              max: 100,
              message:
                "El nombre del cliente no puede exceder los 100 caracteres",
            },
          ]}
        >
          <Input prefix={<UserOutlined />} placeholder="Nombre del Cliente" />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="NIT"
          name="nit"
          tooltip="Número de Identificación Tributaria (requerido para FUEC)"
          rules={[
            {
              max: 20,
              message: "El NIT no puede exceder los 20 caracteres",
            },
          ]}
        >
          <Input prefix={<IdcardOutlined />} placeholder="Ej: 900.123.456-7" />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          label="Nombre del Contacto"
          name="nombre_contacto"
          rules={[
            {
              required: true,
              message: "Por favor ingrese el nombre del contacto",
            },
          ]}
        >
          <Input prefix={<UserOutlined />} placeholder="Nombre del Contacto" />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          label="Teléfono"
          name="telefono"
          rules={[
            {
              required: true,
              message: "Por favor ingrese un número de teléfono",
            },
            {
              pattern: /^[0-9\b]+$/,
              message: "El teléfono solo debe contener números",
            },
            {
              pattern: /^\d{10}$/, // Exactamente 10 dígitos
              message: "El teléfono debe tener 10 dígitos",
            },
          ]}
        >
          <Input
            maxLength={10}
            prefix={<PhoneOutlined />}
            placeholder="Ingrese el teléfono"
          />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          label="Correo Electrónico"
          name="correo_electronico"
          rules={[
            {
              required: true,
              type: "email",
              message: "Por favor ingrese un correo electrónico válido",
            },
            {
              max: 100,
              message:
                "El correo electrónico no puede exceder los 100 caracteres",
            },
          ]}
        >
          <Input prefix={<MailOutlined />} placeholder="Ingrese el correo" />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          label={
            <Tooltip title="Si está activo, este cliente puede gestionar autorizaciones TAI (Transporte Asistencial Interveredal/Intermunicipal/Urbano)">
              <span>
                <CarOutlined style={{ marginRight: 8 }} />
                Cliente TAI
              </span>
            </Tooltip>
          }
          name="es_cliente_tai"
          valuePropName="checked"
        >
          <Switch
            checkedChildren="Sí"
            unCheckedChildren="No"
            onChange={onTaiChange}
            style={{
              backgroundColor: undefined,
            }}
          />
        </Form.Item>
        <Text type="secondary" style={{ fontSize: 12, marginTop: -16, display: 'block' }}>
          Permite gestionar autorizaciones TAI para este cliente
        </Text>
      </Col>

      {/* Selector de clientes EPS relacionados - Solo visible cuando es cliente TAI */}
      {esTai && (
        <Col span={24} style={{ marginTop: 16 }}>
          <Form.Item
            label={
              <Tooltip title="Seleccione los clientes EPS que podrán usar este cliente TAI para sus autorizaciones">
                <span>
                  <LinkOutlined style={{ marginRight: 8 }} />
                  Clientes EPS Relacionados
                </span>
              </Tooltip>
            }
            name="clientes_eps_ids"
          >
            <Select
              mode="multiple"
              placeholder="Seleccione los clientes EPS a relacionar"
              loading={loadingClientesEps}
              value={clientesEpsSeleccionados}
              onChange={onClientesEpsChange}
              optionFilterProp="children"
              showSearch
              allowClear
              style={{ width: '100%' }}
            >
              {clientesEps.map((cliente) => (
                <Option key={cliente.id} value={cliente.id}>
                  {cliente.nombre_cliente}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Text type="secondary" style={{ fontSize: 12, marginTop: -16, display: 'block' }}>
            Los clientes EPS seleccionados podrán crear autorizaciones TAI con este cliente
          </Text>
        </Col>
      )}
    </Row>
  </div>
);

GeneralInfo.propTypes = {
  esTai: PropTypes.bool,
  onTaiChange: PropTypes.func,
  clientesEps: PropTypes.array,
  loadingClientesEps: PropTypes.bool,
  clientesEpsSeleccionados: PropTypes.array,
  onClientesEpsChange: PropTypes.func,
};

export default GeneralInfo;
